<template>
  <PageWithLayout>
    <div class="section section_main" :class="{'_move_image': isTransformImage}">
      <div class="bg_main"></div>
      <div class="inner_section">
        <h2 class="screen_out">스마트팩토리 T-fac 설명</h2>
        <strong class="tit_section">카카오톡을 통해<br/>새로운 '스마트팩토리'를<br/>만들어 갑니다</strong>
        <img src="https://t1.kakaocdn.net/smartfactory/images/service/pc/icon_kakaotalk.png" alt="kakaotalk" class="img_kakaotalk">
        <p class="desc_section">업무진행상황을 한눈에 확인하고 공유할 수 있으며<br/>맞춤형 서비스 제공을 통하여 비용에 대한 부담 없이<br/>서비스를 이용할 수 있습니다.</p>
        <p class="screen_out">T-Fac 챗봇화면</p>
        <img src="https://t1.kakaocdn.net/smartfactory/images/service/pc/main_visual_hand_210401.png" alt="" class="img_phone">
        <span class="mouse_move">
          <img src="https://t1.kakaocdn.net/smartfactory/images/service/pc/img_mouse.png" class="img_mouse">
        </span>
      </div>
    </div>
    <div class="section section_video">
      <div class="inner_section">
        <h3 class="screen_out">T-fac 홍보영상</h3>
        <strong class="tit_section type2"><span class="ico_brand ico_logo"></span>영상으로 보는 티팩 활용기</strong>
        <div class="box_video">
          <video
              class="video_view"
              muted
              controls
              src="https://t1.kakaocdn.net/smartfactory/images/service/video/tfac.mp4"
              poster="https://t1.kakaocdn.net/smartfactory/images/service/video/video_poster.jpg"
              ref="video"
              @play="videoPlay"
              @pause="videoPause"
          >
          </video>
          <button type="button" class="btn_play" @click="clickPlay" v-if="isBtnPlay">
            <span class="ico_brand ico_play type2">재생하기</span>
          </button>
          <!-- <iframe
            width="980"
            height="544"
            src="https://www.youtube.com/embed/h3LAQTng4LY"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe> -->
        </div>
      </div>
    </div>
    <div class="section section_introduce">
      <h3 class="screen_out">T-fac 소개</h3>
      <Swiper class="section_slide" :options="swiperOptions" ref="swipeDom">
        <swiper-slide class="item_slide">
          <div class="inner_section">
            <strong class="tit_section">업무를 쉽고 편리하게<br/>관리해보세요</strong>
            <p class="desc_section">업무용 카카오톡과 챗봇을 통하여<br/>원할환 커뮤니케이션 활동을 지원합니다.</p>
            <div class="img_g img_slide01">채널홈 화면 이미지</div>
          </div>
        </swiper-slide>
        <swiper-slide class="item_slide">
          <div class="inner_section">
            <strong class="tit_section">나만의 업무 비서가<br/>되어드립니다</strong>
            <p class="desc_section">중요 업무, 미확인 업무를 놓치지 않도록<br/>하루 세번 업무 브리핑을 발송합니다.</p>
            <div class="img_g img_slide02">스마트팩토리 서비스 화면 이미지</div>
          </div>
        </swiper-slide>
        <swiper-slide class="item_slide">
          <div class="inner_section">
            <strong class="tit_section">똑똑한 공장<br/>만들어 보세요!</strong>
            <p class="desc_section">AI 기반의 서비스를 통하여 작업 시 필요한<br/>다양한 정보 및 이슈 사항에 대한 정보를 제공합니다.</p>
            <div class="img_g img_slide03">T-Fac 챗봇 화면 이미지</div>
          </div>
        </swiper-slide>
        <swiper-slide class="item_slide">
          <div class="inner_section">
            <strong class="tit_section">업무 누락방지,<br/>히스토리 관리</strong>
            <p class="desc_section">소중한 업무 데이터를 파트 별로 보관 가능합니다.<br/>내가 등록한 업무, 담당업부, 관련업무 별로<br/>조회 가능합니다.</p>
            <div class="img_g img_slide04">스마트팩토리 서비스 화면 이미지</div>
          </div>
        </swiper-slide>
        <swiper-slide class="item_slide">
          <div class="inner_section">
            <strong class="tit_section">서비스에 필요한 모듈만<br/>골라 사용하세요</strong>
            <p class="desc_section">필요한 기능만 모듈단위로 이용할 수 있기 때문에<br/>도입 비용에 대한 부담이 없습니다.</p>
            <div class="img_g img_slide05">T-Fac 챗봇 화면 이미지</div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </Swiper>
      <div class="play_slide">
        <button type="button" class="btn_control" @click="playControl" v-if="isPlaying"><span class="ico_brand ico_stop">정지</span></button>
        <button type="button" class="btn_control" @click="playControl" v-if="!isPlaying"><span class="ico_brand ico_play">재생</span></button>
      </div>
    </div>
    <div class="section section_business" ref="businessDom" :class="{'_start':isAnimationStart}">
      <div class="inner_section">
        <div class="module_top">  
          <h3 class="badge_section">업무모듈<span class="screen_out">설명</span></h3>
        </div>
        <strong class="tit_section">공유를 통한 생산성 향상</strong>
        <p class="desc_section">업무를 등록하고 구성원과 공유 할 수 있으며 실시간으로 진행현황을 확인합니다.</p>
        <div class="wrap_animation">
          <div class="img_animation_g img_01"></div>
          <div class="img_animation_g img_02"></div>
          <div class="img_animation_g img_03"></div>
          <div class="img_animation_g img_04"></div>
          <div class="img_animation_g img_05"></div>
          <div class="img_animation_g img_06"></div>
          <div class="img_animation_g img_07"></div>
          <div class="img_animation_g img_08"></div>
          <div class="img_animation_g img_09"></div>
        </div>
      <!-- <div class="img_g img_business"></div> -->
      </div>
    </div>
    <div class="section section_alarm">
      <div class="inner_section align_right">
        <div class="module_top">
          <h3 class="badge_section">알람모듈<span class="screen_out">설명</span></h3>
        </div>
        <strong class="tit_section">실시간 이슈 확인</strong>
        <p class="desc_section">이상징후가 발생하거나 업무 상태가 변경될 경우<br/>즉시 알람을 전달하고 작업자는 조치내역을 등록합니다.</p>
        <ul class="list_section">
          <li>시스템, 장비 등 이상 징후 발생 시 실시간으로 담당자에게 알람 발송</li>
          <li>발생된 알람 상세내역, 진행상태 조회</li>
          <li>알람 조치 완료시, 조치 사용자 및 조치내역 정보를 실시간으로 알람 전달</li>
          <li>파트 별 설정된 알람 이력 조회</li>
        </ul>
        <!-- <div class="img_g img_alarm"></div> -->
      </div>
    </div>
    <div class="section section_info">
      <div class="inner_section">
        <div class="module_top">
          <h3 class="badge_section">인포모듈<span class="screen_out">설명</span></h3>
        </div>
        <strong class="tit_section">공정현황 모니터링</strong>
        <p class="desc_section">외부 시스템과의 연동을 통하여 공정 현황을 관리하고<br/>모니터링할 수 있습니다.</p>
        <ul class="list_section">
          <li>외부 시스템 연계를 통해 원격 점검</li>
          <li>언제, 어디서든지 공장가동 상태 모니터링</li>
          <li>장비검검 주기 관리 및 알림 서비스 제공</li>
        </ul>
        <div class="img_g img_info"><p class="ir_pm">카카오톡에서 '자재 요청'입력시 T-Fac이 '장비 가동 상태 알림','장비 이상 알림','온도 재설정'을 답해주는 화면</p></div>
      </div>
    </div>
    <div class="section section_document">
      <div class="inner_section">
        <div class="module_top">
          <h3 class="badge_section">문서모듈<span class="screen_out">설명</span></h3>
        </div>
        <strong class="tit_section">문서 작성 및 관리</strong>
        <p class="desc_section">표준화된 문서 작성 기능을 통하여 다양한 형태 작업보고서를 작성하고 관리할 수 있습니다.</p>
        <p class="text_desc">카톡에서 문서 등록 알림을 받고 간단한 클릭, 입력만으로 문서 등록이 가능 합니다.<br>작성 완료된 문서는 자동으로 보고서 타입으로 다운로드가 가능하며 이력 관리도 할 수 있습니다.</p>
        <span class="screen_out">일반문서(일반문서, 지출결의서, 출장계획서) / HACCP 자동화문서</span>
      </div>
    </div>
    <div class="section section_delivery">
      <div class="inner_section align_right">
        <div class="module_top">
          <h3 class="badge_section">콜드체인모듈<span class="screen_out">설명</span></h3>
        </div>
        <strong class="tit_section">운송 관제 서비스</strong>
        <p class="desc_section">운송 과정을 실시간 모니터링하여 제품의 안정성을<br>확보 할 수 있습니다.</p>
        <ul class="list_section">
          <li>차량 정보, 차량 도착 시간, 운송 현황 확인</li>
          <li>차량의 온도, 습도, 충격, 배터리 데이터 모니터링</li>
          <li>운송 과정의 이상 징후 발생시, 알림 발송</li>
          <li>차량의 스케줄 및 배차 관리 지원</li>
        </ul>
        
      </div>
    </div>
    <div class="section section_cluster">
      <div class="inner_section">
        <div class="module_top">
          <h3 class="badge_section">클러스터모듈<span class="screen_out">설명</span></h3>
          <span class="txt_info">오픈예정</span>
        </div>
        <strong class="tit_section">협력사 및 업무 관리</strong>
        <p class="desc_section">협력업체와 구매/발주 및 재고 정보를 공유하여<br/>공정 프로세스의 원활한 유지가 가능합니다.</p>
        <ul class="list_section">
          <li>고객사, 작업자가 구매/발주 요청을 쉽게 할 수 있는 가이드 지원</li>
          <li>구매 / 발주된 누락없이 모아볼 수 있는 기능 제공</li>
          <li>구매 / 발주 이력내용 관리 기능 제공</li>
          <li>구매 / 발주 요청 시, 실시간으로 담당자에게 알림 발송</li>
        </ul>
      </div>
    </div>
    <div class="section section_connect">
      <div class="inner_section">
        <h3 class="screen_out">파트너사 문의하기</h3>
        <p class="desc_section">제조혁신을 도모하는 파트너사들과 협력하여<br/>스마트팩토리 서비스를 함께 만들어 갑니다.</p>
        <p class="text_desc">T-fac은 카카오의 AI 및 전문기술 기반으로 파트너사의 솔루션 경쟁력을 더하여<br/>스마트팩토리 산업의 더 편리하고 더 가치있는 서비스를 만들고자<br/>파트너사들과 함께 노력하고있습니다.</p>
        <div ref="connectBtn" class="btnbox_g">
<!--          <a href="/inquire" target="_blank" class="btn_inquiry">-->
          <a href="javascript:void(0)" class="btn_inquiry" @click="moveToInquire">
            <span class="text">파트너사 문의</span>
            <span class="arrow_area">
              <span class="arrow"></span>
            </span>
            <span class="circle"></span>
          </a>
        </div>
      </div>
    </div>
    <div class="section section_service">
      <h3 class="screen_out">서비스 가입신청</h3>
      <strong class="tit_section">기업의 사용목적과 규모에 따라<br/>스마트팩토리 서비스를 선택해보세요</strong>
      <div class="btnbox_g">
        <!--        <button class="btn_service type1" @click="onClickService">서비스 신청하기</button>-->
        <a href="https://t1.kakaocdn.net/smartfactory/assets/images/service/pdf/tfac_intro.pdf" target="_blank" class="btn_service type_line"><span class="ico_brand ico_download"></span>서비스 소개서</a>
      </div>
    </div>
  </PageWithLayout>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import PageWithLayout from '@/components/layout/PageWithLayout';
// swiper 6.0 적용 방법 https://github.com/surmon-china/vue-awesome-swiper/issues/680
// import {Swiper as SwiperClass, Pagination, Navigation, Autoplay} from 'swiper/swiper.esm.js'
// import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import Api from "../../api/serviceApi";
import _ from "lodash";
// Swiper modules
// SwiperClass.use([Pagination, Navigation, Autoplay]);
// local component
// const {directive} = getAwesomeSwiper(SwiperClass);


import TiaraService from "@/plugins/TiaraService";
const tiaraService = TiaraService.getService();

export default {
  name: 'Introduce',
  components: {
    PageWithLayout,
    Swiper,
    SwiperSlide,
  },
  // directives: {
  //   swiper: directive
  // },
  data() {
    return {
      swiperOptions: {
        // effect: 'fade',
        pagination: {
          el: ".swiper-pagination",
          clickable: false,
          type: "bullets"
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false, // 자동재생 중 움직였을때 바로 다시 자동재생을 막을지 유무
          waitForTransition: false // 자동재생 중 슬라이드내의 모션을 기다릴 것인지 유무
        },
        // Some Swiper option/callback...
      },
      isPlaying: true,
      isTransformImage: false,
      isAnimationStart: false,
      isBtnPlay: true,
    }
  },
  mounted() {
    this.isTransformImage = true;
    this.addScrollEvent();
    tiaraService.trackPage('서비스소개');
  },
  destroyed() {
    this.removeScrollEvent();
  },
  methods:{
    playControl() {
      if(this.isPlaying) {
        this.isPlaying = false;
        this.$refs.swipeDom.$swiper.autoplay.stop();
      } else {
        this.isPlaying = true;
        this.$refs.swipeDom.$swiper.autoplay.start();
      }
    },
    async onClickService(){
      // this.$router.push({
      //   path: this.$routerPath.JOIN
      // })
      try {
        const response = await Api.serviceReg();
        // alert(response.data.result[0].kakaoLoginUrl)
        location.href = response.data.result[0].kakaoLoginUrl;
      } catch (error) {
        //
      }
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.checkScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.checkScroll)
    },
    checkScroll() {
      if(this.$refs.businessDom.offsetTop - 500 < window.pageYOffset) {
        this.scrollEndTrigger();
      }
    },
    scrollEndTrigger: _.debounce(function() {
      this.animationEffect()
    }, 20),
    animationEffect() {
      this.isAnimationStart = true;
    },
    clickPlay() {
      this.isBtnPlay = false;
      this.$refs.video.play();
    },
    videoPlay() {
      this.isBtnPlay = false;
    },
    videoPause() {
      if(this.$refs.video.readyState === 1) {
        this.isBtnPlay = false;
        return;
      }
      this.isBtnPlay = true;
    },
    moveToInquire() {
      this.$router.push( { name: 'Inquire', query: { type: 'partner' } } );
    }
  }
}
</script>
<style scoped>
/* common style */
.section {overflow: hidden;}
.inner_section{position:relative;width:1080px;margin:0 auto;box-sizing:border-box}
.inner_section.align_right{padding-left:670px;box-sizing:border-box}
.badge_section{display:inline-block;border:1px solid #999;border-radius:20px;padding:6px 24px 8px;font-weight:400;font-size:14px;line-height:24px;color:#222;vertical-align:top}
.module_top .txt_info{display:inline-block;position:relative;margin:9px 0 0 16px;padding-left:17px;font-size:14px;font-weight:300;color:#555;}
.module_top .txt_info:after{position:absolute;top:3px;left:0;width:1px;height:16px;background-color:#d8d8d8;content:''}
.module_top + .tit_section{margin-top:20px}
.tit_section{display:inline-block;font-weight:normal;font-family:'NotoSansKR_DL', sans-serif;font-size:44px;line-height:56px;color:#222;letter-spacing:-.05em}
.tit_section.type2{font-family:'NotoSansKR_M';font-weight:500;}
.desc_section{margin-top:32px;font-size:18px;line-height:28px;color:#666;letter-spacing:-.05em}
.list_section{margin-top:20px}
.list_section li{position:relative;padding-left:12px; font-family:'NotoSansKR_L', sans-serif;font-size:14px;line-height:26px;color:#555;letter-spacing:-0.5px}
.list_section li:after{position:absolute;top:13px;left:0;width:2px;height:2px;border-radius:50%;background-color:#222;content:''}
.img_g{position:absolute;display:block;overflow:hidden;font-size:0;line-height:0;text-indent:-9999px}
.text_desc{display:inline-block;font-family:'NotoSansKR_L', sans-serif;font-size:14px;line-height:26px;color:#555;letter-spacing:-0.5px}
.desc_section + .text_desc{margin-top:10px}
/* section main */
.section_main {overflow: hidden;position:relative;height: 860px;}
.section_main .bg_main {position:absolute;top:0;left:0;width:100%;height:100%;background: url(https://t1.kakaocdn.net/smartfactory/images/service/pc/main_visual.jpg) no-repeat 50% 0;background-size: auto 100%;transform: scale(1.3);-ms-transform:scale(1.3);-o-transform:scale(1.3);-moz-transform:scale(1.3);-webkit-transform:scale(1.3);}
.section_main._move_image .bg_main {transform: scale(1);-ms-transform:scale(1);-o-transform:scale(1);-moz-transform:scale(1);-webkit-transform:scale(1);transition: transform 5s ease-in;-ms-transition: transform 5s ease-in;-o-transition: transform 5s ease-in;-moz-transition: transform 5s ease-in;-webkit-transition: transform 5s ease-in;}
.section_main .inner_section {position: relative;z-index:1;height: 100%}
.section_main .tit_section {padding-top:278px;font-family:'NotoSansKR_M', sans-serif;font-size: 48px;line-height: 66px;color: #000;}
.section_main .img_kakaotalk{position: absolute;top: 225px;left:300px;}
.section_main .desc_section{margin-top: 29px;font-size: 16px;line-height: 24px;color: #222;}
.section_main .img_phone{position: absolute;bottom: 0;right:-200px;width:716px;height:747px;}
.section_main .mouse_move{position:absolute;display: inline-block;bottom:44px;left:50%;margin-left:-40px;animation: mouseEffect 1s infinite forwards;}
/* section video */
.section_video{background-color:#f5f5f5;}
.section_video .inner_section{padding: 100px 0 104px 0;text-align: center;}
.section_video .box_video{position: relative;width: 980px;margin: 56px auto 0;cursor: pointer;}
.section_video .box_video:hover .btn_play{background-color:#000}
.section_video .video_view{width:100%;vertical-align:top}
.section_video .video_view[poster]{width:100%;height:100%}
.section_video .ico_logo{margin:7px 20px 0 0}
.btn_play{position:absolute;top:50%;left:50%;width:70px;height:50px;margin:-25px 0 0 -35px;border-radius:14px;background-color:rgba(0, 0, 0, 0.53);vertical-align:top;font-size:0}
.btn_play .ico_play{position:absolute;top:50%;left:50%;margin:-11px 0 0 -7px}
/* section slide */
.section_slide .item_slide{height:860px;background-repeat:no-repeat;background-size:574px 557px}
.section_slide .inner_section{position:relative;padding:313px 0 0 670px;box-sizing:border-box}
.section_slide .desc_section{margin-top:20px}
.section_slide .img_g{top:153px;left:-13px;width:630px;height:558px}
.section_slide .img_slide01{background-image:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/slide01.png)}
.section_slide .img_slide02{background-image:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/slide02_201223.png)}
.section_slide .img_slide03{background-image:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/slide03.png)}
.section_slide .img_slide04{background-image:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/slide04_201223.png)}
.section_slide .img_slide05{background-image:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/slide05_210401.png)}
.play_slide{position:relative;width:1080px;margin:0 auto;}
.play_slide .btn_control{position:absolute;bottom:262px;left:765px;z-index:10;padding:5px;font-size:0}
/* section business */
.section_business{position:relative;background-color:#ABC0D1;text-align:center}
.section_business .inner_section{height:900px;padding-top:100px;box-sizing:border-box;}
.section_business .desc_section{margin-top:22px}
.wrap_animation{position:relative;overflow:hidden;width:840px;height:592px;margin:40px auto;}
.wrap_animation .img_animation_g{position:absolute;background-size:750px 580px;background-repeat: no-repeat;}
.wrap_animation .img_01{top:60px;left:246px;opacity:0;width:311px;height:397px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/ani_01.png) 0 0 no-repeat;}
.wrap_animation .img_02{top:60px;left:444px;opacity:0;width:106px;height:39px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/ani_02.png) 0 0 no-repeat;}
.wrap_animation .img_03{top:60px;left:246px;opacity:0;width:311px;height:440px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/ani_03.png) 0 0 no-repeat;}
.wrap_animation .img_04{top:462px;left:296px;opacity:0;width:261px;height:120px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/ani_04.png) 0 0 no-repeat;}
.wrap_animation .img_05{top:462px;left:559px;opacity:0;width:261px;height:120px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/ani_05.png) 0 0 no-repeat;}
.wrap_animation .img_06{top:60px;left:458px;opacity:0;width:92px;height:39px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/ani_06.png) 0 0 no-repeat;}
.wrap_animation .img_07{top:60px;left:246px;opacity:0;width:311px;height:356px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/ani_07.png) 0 0 no-repeat;}
.wrap_animation .img_08{top:378px;left:296px;opacity:0;width:261px;height:120px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/ani_08.png) 0 0 no-repeat;}
.wrap_animation .img_09{top:378px;left:559px;opacity:0;width:261px;height:120px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/ani_09.png) 0 0 no-repeat;}
.section_business._start .img_01{animation: effect1 20s infinite forwards;}
.section_business._start .img_02{animation: effect2 20s infinite forwards;}
.section_business._start .img_03{animation: effect3 20s infinite forwards;}
.section_business._start .img_04{animation: effect5 20s infinite forwards;}
.section_business._start .img_05{animation: effect4 20s infinite forwards;}
.section_business._start .img_06{animation: effect6 20s infinite forwards;}
.section_business._start .img_07{animation: effect7 20s infinite forwards;}
.section_business._start .img_08{animation: effect9 20s infinite forwards;}
.section_business._start .img_09{animation: effect8 20s infinite forwards;}
/* section alarm */
.section_alarm{position:relative;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/bg_module_alarm_210401.jpg) no-repeat 50% 0}
.section_alarm .inner_section{position:static;height:860px;padding-top:241px}
.img_alarm{top:0;left:0;width:288px;height:368px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/img_module_alarm.png) no-repeat 0% 0;background-size:288px 368px}
@media screen and (max-width: 1920px){
  .img_alarm{top:0;left:50%;margin-left:-960px}
}
/* section cluster */
.section_cluster{background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/bg_module_cluster_210709.jpg) no-repeat 50% 0}
.section_cluster .inner_section{height:860px;padding-top:240px}
/* section info */
.section_info{position:relative;overflow:hidden;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/bg_module_info.jpg) no-repeat 50% 0}
.section_info .inner_section{padding-top:240px;height:860px}
.section_info .img_info{top:84px;right:-216px;width:669px;height:739px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/img_module_info_201217.png) no-repeat 0 0}
.section_info .badge_section,
.section_info .tit_section,
.section_info .desc_section,
.section_info .list_section li{color:#fff}
.section_info .list_section li:after{background-color:#fff}
/* section document */
.section_document{background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/bg_module_document_210401.jpg) no-repeat 50% 0}
.section_document .inner_section{padding-top:100px;height:860px;text-align:center}
/* delivery */
/* cluster */
.section_delivery{background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/bg_module_delivery.jpg) no-repeat 50% 0}
.section_delivery .inner_section{height:860px;padding-top:240px}
/* connect */
.section_connect {padding:178px 0;background-color:#ffe500;}
.section_connect .desc_section{margin-top:0;font-size:32px;line-height:44px;color:#333}
.section_connect .text_desc{font-size:18px;line-height:28px;}
.section_connect .desc_section + .text_desc {margin-top:32px;}
.section_connect .btnbox_g{position:absolute;bottom:0;right:0;}
.section_connect .btnbox_g .btn_inquiry{display:inline-block;font-size:24px;line-height:1;color:#46485b;}
.section_connect .btn_inquiry .text{line-height:36px;}
.section_connect .btn_inquiry .text, .section_connect .btn_inquiry .arrow_area{position:relative;z-index:1;display:inline-block;vertical-align:middle;}
.section_connect .btn_inquiry .arrow_area {overflow:hidden;width: 51px;margin-left: 6px;padding:10px 0;}
.section_connect .btn_inquiry .arrow {position:relative;display:block;width: 100%;height: 2px;background-color: #46485b;animation: arrowEffect .5s infinite alternate ease-in;}
.section_connect .btn_inquiry .arrow:before {position: absolute;top: 2px;right: 0;width: 12px;height: 12px;border-right: 2px solid #121212;transform: rotate(60deg);transform-origin: top right;content: '';}
.section_connect .btn_inquiry .arrow:after{position: absolute;top: 0;right: 0;width: 12px;height: 12px;border-top: 2px solid #121212;transform: rotate(30deg);transform-origin: top right;content: '';}
.section_connect .btn_inquiry .circle{position:absolute;top:50%;right:-27px;width:108px;height:108px;margin-top:-54px;border-radius:50%;background-color:#fff;animation: circleScale .5s infinite alternate ease-in;}
/* service */
.section_service{padding:100px 0 114px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/bg_service.jpg) no-repeat 50% 0;background-size:auto 440px;text-align:center}
.section_service .tit_section{font-size:32px;line-height:47px;color:#fff}
.section_service .btnbox_g{margin-top:52px}
.section_service .btn_service{display:inline-block;width:300px;height:80px;margin:0 6px;line-height:1;border-radius:3px;font-family:'NotoSansKR_M', sans-serif;font-size:24px;letter-spacing:-0.2px;background-color:#FFE500;color:#222}
.section_service .btn_service:hover{background-color:#E3CC00}
.section_service .btn_service.type_line{border:2px solid #fff;background-color:transparent;color:#fff;}
.section_service .btn_service .ico_download{margin:2px 12px 0 0}
.section_service a.btn_service{vertical-align:top;padding-top:26px;box-sizing:border-box;}

@keyframes circleScale {
  0% {transform:scale(0.8);}
  100% {transform: scale(1);}
}
@keyframes arrowEffect {
  0% {transform: translateX(-50%);}
  100% {transform: translateX(0);}
}
@keyframes mouseEffect {
  0%   {bottom:49px;}
  50%  {bottom:39px;}
  100% {bottom:49px;}
}
/* cubic-bezier(0,1,.6,1) */
@keyframes effect1 {
  0%   {top:80px;opacity:0;}
  3%   {top:20px;opacity:1;}
  17%  {top:20px;opacity:1;}
  20%  {top:-60px;opacity:0;}
  99%  {top:-60px;opacity:0;}
  100% {top:80px;opacity:0;}
}
@keyframes effect2 {
  0%   {top:60px;opacity:0;}
  18%  {top:60px;opacity:0;}
  21%  {top:20px;opacity:1;}
  32%  {top:20px;opacity:1;}
  35%  {top:-47px;opacity:0;}
  99%  {top:-47px;opacity:0;}
  100% {top:60px;opacity:0;}

}
@keyframes effect3 {
  0%   {top:127px;opacity:0;}
  22%  {top:127px;opacity:0;}
  25%  {top:67px;opacity:1;}
  32%  {top:67px;opacity:1;}
  35%  {top:20px;opacity:1;}
  57%  {top:20px;opacity:1;}
  60%  {top:-40px;opacity:0;}
  99%  {top:-40px;opacity:0;}
  100% {top:127px;opacity:0;}
}
@keyframes effect4 {
  0%   {left:196px;top:462px;opacity:0;}
  37%  {left:196px;top:462px;opacity:0;}
  40%  {left:296px;top:462px;opacity:1;}
  42%  {left:296px;top:462px;opacity:1;}
  45%  {left:559px;top:462px;opacity:1;}
  57%  {left:559px;top:462px;opacity:1;}
  60%  {left:559px;top:402px;opacity:0;}
  99%  {left:559px;top:402px;opacity:0;}
  100% {left:196px;top:462px;opacity:0;}
}
@keyframes effect5 {
  0%   {left:296px;top:522px;opacity:0;}
  42%  {left:296px;top:522px;opacity:0;}
  45%  {left:296px;top:462px;opacity:1;}
  57%  {left:296px;top:462px;opacity:1;}
  60%  {left:296px;top:402px;opacity:0;}
  99%  {left:296px;top:402px;opacity:0;}
  100% {left:296px;top:522px;opacity:0;}
}
@keyframes effect6 {
  0%   {top:60px;opacity:0;}
  58%  {top:60px;opacity:0;}
  61%  {top:20px;opacity:1;}
  72%  {top:20px;opacity:1;}
  75%  {top:-67px;opacity:0;}
  99%  {top:-67px;opacity:0;}
  100% {top:60px;opacity:0;}

}
@keyframes effect7 {
  0%   {top:127px;opacity:0;}
  62%  {top:127px;opacity:0;}
  65%  {top:67px;opacity:1;}
  72%  {top:67px;opacity:1;}
  75%  {top:20px;opacity:1;}
  94%  {top:20px;opacity:1;}
  98%  {top:-20px;opacity:0;}
  99%  {top:-20px;opacity:0;}
  100% {top:127px;opacity:0;}
}
@keyframes effect8 {
  0%   {left:196px;top:378px;opacity:0;}
  77%  {left:196px;top:378px;opacity:0;}
  80%  {left:296px;top:378px;opacity:1;}
  82%  {left:296px;top:378px;opacity:1;}
  85%  {left:559px;top:378px;opacity:1;}
  94%  {left:559px;top:378px;opacity:1;}
  98%  {left:559px;top:338px;opacity:0;}
  99%  {left:559px;top:338px;opacity:0;}
  100% {left:196px;top:378px;opacity:0;}
}
@keyframes effect9 {
  0%   {left:296px;top:428px;opacity:0;}
  82%  {left:296px;top:428px;opacity:0;}
  85%  {left:296px;top:378px;opacity:1;}
  94%  {left:296px;top:378px;opacity:1;}
  98%  {left:296px;top:338px;opacity:0;}
  99%  {left:296px;top:338px;opacity:0;}
  100% {left:296px;top:428px;opacity:0;}
}
</style>
